import { render, staticRenderFns } from "./Templateyh_3.vue?vue&type=template&id=a7469d84&scoped=true&"
import script from "./Templateyh_3.vue?vue&type=script&lang=js&"
export * from "./Templateyh_3.vue?vue&type=script&lang=js&"
import style0 from "./Templateyh_3.vue?vue&type=style&index=0&id=a7469d84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7469d84",
  null
  
)

export default component.exports